module.exports = __webpack_public_path__ + "img/google-play-badge-fr.e41cb872.png";